module.exports = __webpack_public_path__ + "img/personal20.fb7d631e.jpeg";